var _excluded = ["children", "className", "defaultTypeStyle", "expandedAccordionPanels", "id", "mobileTypeStyle", "noShadow", "offsetYHeight", "onClickAccordionItem", "setAutoHeight", "size", "v2"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
require("../accordion-v2/accordion.css");
var styles = {
  "accordion": "accordion-2_0Rp",
  "accordionv1": "accordionv1-4kBHK",
  "accordionLarge": "accordionLarge-2RgvH",
  "accordionMedium": "accordionMedium-14kfQ",
  "accordionNoShadow": "accordionNoShadow-3YDmM"
};
import { getStateKey } from '../accordion-v2/util';
var AccordionStatelessV2 = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      children,
      className,
      defaultTypeStyle,
      expandedAccordionPanels,
      id,
      mobileTypeStyle,
      noShadow,
      offsetYHeight,
      onClickAccordionItem,
      setAutoHeight,
      size,
      v2
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var onAccordionHeaderClick = useCallback(_ref2 => {
    var {
      stateKey,
      expanded
    } = _ref2;
    if (onClickAccordionItem) {
      onClickAccordionItem(stateKey, expanded);
    }
  }, [onClickAccordionItem]);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    className: cs(styles.accordion, className, {
      [styles.accordionv1]: !v2,
      [styles.accordionLarge]: !v2 && size === 'large',
      [styles.accordionNoShadow]: !v2 && noShadow
    }),
    "data-testid": "accordion"
  }, otherProps), React.Children.map(children, (child, index) => {
    var stateKey = getStateKey(child, index);
    return /*#__PURE__*/React.cloneElement(child, {
      stateKey,
      size,
      accordionId: id,
      noShadow,
      expanded: expandedAccordionPanels[stateKey],
      handleClick: onClickAccordionItem ? onAccordionHeaderClick : null,
      'data-testid': "accordion-".concat(stateKey),
      v2,
      defaultTypeStyle,
      mobileTypeStyle
    }, child.props.children);
  }));
});
AccordionStatelessV2.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  /** For v2 accordion, the type style to be used. */
  defaultTypeStyle: PropTypes.oneOf(['medium', 'small', 'xsmall', 'body-1']),
  /** State prop that controls the opening and closing of panels */
  expandedAccordionPanels: PropTypes.shape({}).isRequired,
  id: PropTypes.string.isRequired,
  /** For v2 accordion, the type style to be used on mobile-only. */
  mobileTypeStyle: PropTypes.oneOf(['medium', 'small', 'xsmall', 'body-1']),
  /** Deprecated for v2 accordion. Stylistic variation where box-shadows and horizontal padding are removed. */
  noShadow: PropTypes.bool,
  offsetYHeight: PropTypes.number,
  /** Function invoked on clicking an accordion panel. Can also be used to update the expandedAccordionPanels state prop */
  onClickAccordionItem: PropTypes.func,
  setAutoHeight: PropTypes.bool,
  /** Deprecated for v2 accordion. */
  size: PropTypes.oneOf(['small', 'large']),
  /** Toggle the new Version 2 type styles */
  v2: PropTypes.bool
};
AccordionStatelessV2.defaultProps = {
  className: null,
  defaultTypeStyle: 'body-1',
  mobileTypeStyle: undefined,
  noShadow: false,
  offsetYHeight: 0,
  // default to a function not undefined as removes downstream logic to check if prop is a valid function before calling it.
  onClickAccordionItem: null,
  setAutoHeight: true,
  size: 'small',
  v2: false
};
export default AccordionStatelessV2;